import {createSlice} from "@reduxjs/toolkit"
//createSlice 创建store的方法
const userStore = createSlice({
    name : 'user', //给模块一个名字
    initialState:{
        userInfo:localStorage.getItem('ai-chat-userinfo')?JSON.parse(localStorage.getItem('ai-chat-userinfo')):null,
        authId:localStorage.getItem('ai-chat-auth-id') || null,
        allContextMeta:localStorage.getItem('ai-chat-all-context-meta')?JSON.parse(localStorage.getItem('ai-chat-all-context-meta')):null,
        currencies:localStorage.getItem('ai-chat-currencies')?JSON.parse(localStorage.getItem('ai-chat-currencies')):null,
        rememberSvg:localStorage.getItem('ai-chat-remember-svg') || 'show', // 0显示 1不显示
        leftIndex:localStorage.getItem('ai-chat-left-index') || '9981'
    }, //初始化state
    reducers :{
        setUserInfo(state,action){
            localStorage.setItem('ai-chat-userinfo',JSON.stringify(action?.payload))
            state.userInfo = action?.payload || null
        },
        setAuthId(state,action){
            localStorage.setItem('ai-chat-auth-id',action?.payload)
            state.authId = action?.payload || null
        },
        setAllContextMeta(state,action){
            localStorage.setItem('ai-chat-all-context-meta',JSON.stringify(action?.payload))
            state.allContextMeta = action?.payload || null
        },
        setCurrencies(state,action){
            localStorage.setItem('ai-chat-currencies',JSON.stringify(action?.payload))
            state.currencies = action?.payload || null
        },
        setRememberSvg(state,action){
            localStorage.setItem('ai-chat-remember-svg',action?.payload)
            state.rememberSvg = action?.payload || null
        },
        setLeftIndex(state,action){
            localStorage.setItem('ai-chat-left-index',action?.payload)
            state.leftIndex = action?.payload || null
        }
    }//修改状态的方法 同步方法 支持直接修改
})

//解构
const {setUserInfo,setAuthId,setAllContextMeta,setCurrencies,setRememberSvg,setLeftIndex} = userStore.actions

//获取reducer函数
const reducer = userStore.reducer
//导出创建action对象的函数和reducer函数
export {setUserInfo,setAuthId,setAllContextMeta,setCurrencies,setRememberSvg,setLeftIndex}
export default reducer
